/**
 * The marker every screen in this folder carries.
 *
 * §13 of the brief keeps the seven management screens the product grew after the prototype was
 * frozen, and is explicit about how they may be reported: «Referansı olmayan ekranlar için sahte
 * pixel-parity PASS yazma; "aynı design system + PO manual acceptance required" olarak raporla.»
 *
 * So these screens are built from the reference's own shell, page head, card, table, filter,
 * detail, timeline and modal — the same design system, nothing invented — and each one says on
 * its face that it has no baseline to be measured against. A reviewer can then tell at a glance
 * which screens the 0.5% threshold applies to and which ones only their own judgement covers.
 */
import type { ReactElement } from 'react';

export function DerivedNotice({ note }: { note: string }): ReactElement {
  return (
    <div className="warn-box small" style={{ marginBottom: 18 }}>
      <b>Ek ürün ekranı · prototipte referansı yok.</b> {note} Aynı design system kullanıldı; piksel
      karşılaştırması yapılmaz, Product Owner'ın elle kabulü gerekir.
    </div>
  );
}
